/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface HubbleMapCompany
 */
export interface HubbleMapCompany {
  /**
   *
   * @type {string}
   * @memberof HubbleMapCompany
   */
  companyName: string;
  /**
   *
   * @type {string}
   * @memberof HubbleMapCompany
   */
  companyId: string;
}

/**
 * Check if a given object implements the HubbleMapCompany interface.
 */
export function instanceOfHubbleMapCompany(
  value: object,
): value is HubbleMapCompany {
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  return true;
}

export function HubbleMapCompanyFromJSON(json: any): HubbleMapCompany {
  return HubbleMapCompanyFromJSONTyped(json, false);
}

export function HubbleMapCompanyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HubbleMapCompany {
  if (json == null) {
    return json;
  }
  return {
    companyName: json["companyName"],
    companyId: json["companyId"],
  };
}

export function HubbleMapCompanyToJSON(json: any): HubbleMapCompany {
  return HubbleMapCompanyToJSONTyped(json, false);
}

export function HubbleMapCompanyToJSONTyped(
  value?: HubbleMapCompany | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyName: value["companyName"],
    companyId: value["companyId"],
  };
}
